export default __webpack_public_path__ + "logo-section-v3.png";